import { combineReducers } from 'redux';
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase';
import authReducer from './authReducer';
import signupModalReducer from './signupModalReducer';
import subscribeModalReducer from './subscribeModalReducer';
import companyReducer from './companyReducer';
import campaignsReducer from './campaignsReducer';
import dealsReducer from './dealsReducer';
import notificationsReducer from './notificationsReducer';
import dealStateReducer from './dealStateReducer';
import paymentsReducer from './paymentsReducer';
import youtubeReducer from './youtubeReducer';
import relevantInfluencersReducer from './relevantInfluencersReducer';
import relevantCampaignsReducer from './relevantCampaignsReducer';
import productsReducer from './productsReducer';
import searchResultsReducer from './searchResultsReducer';
import historicalReducer from './historicalReducer';
import financesReducer from './financesReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer,
  signupModal: signupModalReducer,
  subscribeModal: subscribeModalReducer,
  company: companyReducer,
  campaigns: campaignsReducer,
  deals: dealsReducer,
  notifications: notificationsReducer,
  dealState: dealStateReducer,
  payments: paymentsReducer,
  youtube: youtubeReducer,
  relevantInfluencers: relevantInfluencersReducer,
  relevantCampaigns: relevantCampaignsReducer,
  products: productsReducer,
  search: searchResultsReducer,
  historical: historicalReducer,
  finances: financesReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js